import "./OurStory.module.css";
import TopNavigation from "@/reusable_sections/Header";
import TheJourneyToDeepTaste from "./sections/TheJourneyToDeepTaste";
import OurQualityPromise from "./sections/OurQualityPromise";
import FooterSection from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <TopNavigation />
      <TheJourneyToDeepTaste />
      <OurQualityPromise />
      <FooterSection />
    </div>;
}